import { render } from "./AllocationPosition.vue?vue&type=template&id=040d127a&scoped=true"
import script from "./AllocationPosition.vue?vue&type=script&lang=js"
export * from "./AllocationPosition.vue?vue&type=script&lang=js"

import "./AllocationPosition.vue?vue&type=style&index=0&id=040d127a&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-040d127a"

export default script